export default function ({ $config, route, redirect }) {
  if (!$config.settingsOptions?.integrations) {
    const orgId = route.params.orgId
    return redirect(`/org/${orgId}/integrations`)
  }
}
